import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { env } from 'process';

@Injectable({
  providedIn: 'root'
})
export class AnimaltypesService {

  constructor(
    private _http:HttpClient
  ) { }

  public getPaginatedAnimalTypes(page, pp): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/animaltypes?page=${page}&pp=${pp}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getAnimalType(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/admin/animaltype/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updateAnimalType(id:number, name:string): Observable<any>{
    return this._http.put(environment.apiEndpoint + '/api/admin/animaltype/'+id, {name:name}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public addAnimalType(name:string): Observable<any>{
    return this._http.post(environment.apiEndpoint + '/api/admin/animaltype', {name:name}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
